import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/system/Container';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasErrors } from '../../../common/enums';
import { AuthorizedEmail } from '../../../common/models/authorizedEmails';
import { selectAuthorisedEmailUser } from '../../../common/selectors/user';
import { adminSlice } from '../../../common/store/admin';
import { authorizedEmailSlice } from '../../../common/store/authorizedEmails';
import { AppState, appStore, authorizedEmailSelector, franchiseSelector } from '../../../common/store/store';
import { deleteData, postData } from '../../api';


const SelectFranchise = (props: { model: AuthorizedEmail; }) => {

    const franchises = useSelector((state: AppState) => franchiseSelector.selectAll(state));

    const switchFranchise = async (id: number | null) => {
        const response = await postData<AuthorizedEmail>('authorizedEmails', {
            id: props.model.id,
            franchiseId: id
        });
        if (!hasErrors(response)) {
            appStore.dispatch(authorizedEmailSlice.actions.upsertOne(response));
        }
    };

    return <Select label='Franchise liée' size='small' value={props.model.franchiseId ?? ''} onChange={(event) => {
        if (!event.target.value) {
            switchFranchise(null);
        } else {
            switchFranchise(parseInt(event.target.value + ''));
        }
    }}><MenuItem value="">Aucune</MenuItem>{franchises.map(f => <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>)}</Select>;
};

const SelectAdmin = (props: { model: AuthorizedEmail; }) => {


    const switchAdmin = async (value: string) => {
        const response = await postData<AuthorizedEmail>('authorizedEmails', {
            id: props.model.id,
            isAdmin: value === '1'
        });
        if (!hasErrors(response)) {
            appStore.dispatch(authorizedEmailSlice.actions.upsertOne(response));
        }
    };

    return <Select size='small' value={props.model.isAdmin == true ? '1' : '0'} onChange={(event) => {
        switchAdmin(event.target.value);
    }}><MenuItem value="1">Admin</MenuItem><MenuItem value="0">Non-admin</MenuItem></Select>;
};

const AuthorizedEmailItem = (props: { ae: AuthorizedEmail; }) => {
    const user = useSelector((state: AppState) => selectAuthorisedEmailUser(state, props.ae.email));
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, props.ae?.franchiseId ?? 0));

    const onDeleteClick = async () => {
        if (confirm(`Supprimer l'accès de ${props.ae.email} ?`)) {
            const response = await deleteData('authorizedEmails', props.ae.id);
            if (response === true) {
                appStore.dispatch(authorizedEmailSlice.actions.removeOne(props.ae.id));
            }
        }
    };

    return <ListItem secondaryAction={<Button size='small' onClick={onDeleteClick}><DeleteIcon /></Button>}>
        <ListItemAvatar>
            <Avatar style={{ backgroundColor: user ? '#0F0' : '#F00' }}>
                <PersonIcon />
            </Avatar>
        </ListItemAvatar>
        <ListItemText primary={props.ae.email} secondary={<><SelectFranchise model={props.ae} /><SelectAdmin model={props.ae} /></>} />
    </ListItem>;
};

export const Authorisations = () => {

    const authorizedEmails = useSelector((state: AppState) => authorizedEmailSelector.selectAll(state));

    const newAuthorizedEmail = useSelector((state: AppState) => state.admin.newAuthorizedEmail);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();
    const onAjouterClick = async () => {
        const response = await postData<AuthorizedEmail>('authorizedEmails', newAuthorizedEmail);
        if (hasErrors(response)) {
            setErr(response);
        } else {
            setErr(undefined);
            appStore.dispatch(authorizedEmailSlice.actions.addOne(response));
            appStore.dispatch(adminSlice.actions.updateNewAuthorizedEmail({ email: '' }));

        }
    };

    return <Master><Container maxWidth={false}><Typography variant={'h1'}>Administrateurs</Typography>
        <List>
            {authorizedEmails.map(ae => <AuthorizedEmailItem key={ae.id} ae={ae} />)}
        </List>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flexGrow: 1 }}>
                <TextField
                    fullWidth
                    value={newAuthorizedEmail.email}
                    onChange={(event) => {
                        appStore.dispatch(adminSlice.actions.updateNewAuthorizedEmail({ email: event.target.value }));
                    }}
                    type='email'
                    required
                    size='small'
                    sx={{ width: '100%' }}
                    error={!!err?.find(p => p.param == 'email')}
                    helperText={err?.find(p => p.param == 'email')?.msg}
                    placeholder='adress@courriel.com à ajouter' />
            </Box>
            <Box>
                <Button
                    disabled={newAuthorizedEmail.email == ''}
                    size='small'
                    variant='contained'
                    onClick={onAjouterClick}>Ajouter</Button>
            </Box>
        </Box>
    </Container></Master>
        ;
};
